import { render, staticRenderFns } from "./OrderdashBoared.vue?vue&type=template&id=15651edf&"
import script from "./OrderdashBoared.vue?vue&type=script&lang=js&"
export * from "./OrderdashBoared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports